<div class="sidebar-account" #container [ngClass]="{'slide-menu-active': showMenu}" (click)="toggleMenu()">
  <aside (click)="$event.stopImmediatePropagation();" class="wrapper-menu"
    [ngClass]="{'wrapper-menu-active': showMenu}">
    <div class="sidebar-account-menu">
      <div class="header-sidebar">
        <img src="./assets/images/core/icone-unico.svg" alt="unico | people" width="40" height="40">
        <button type="button" aria-label="Fecha menu lateral" (click)="toggleMenu()"></button>
      </div>
      <div class="sidebar-menu first">
        <h3 class="sidebar-account_subtitle">Empresa</h3>
        <ul>
          <li class="open-companies-container">
            <button class="open-companies-mini" type="button" (click)="toggleTab()"
              attr.aria-label="Abrir aba de empresas da {{acc?.name}}." data-test="btnOpenListCompanies">
              <span class="current-company-mini-image" [attr.data-name]="acc?.name | slice:0:1">
                <img *ngIf="acc?.customFields?.brand !== null"
                  src="{{url}}/t/100x100,q100/{{acc?.customFields?.brand?.path}}" alt="Logo da empresa">
              </span>
              <p class="current-company-mini-title" title="{{acc?.name}}">{{acc?.name}}</p>
            </button>
          </li>
          <li>
            <a href="{{adminUrl}}" (click)="toggleMenu('candidate')" class="option-menu ico-admission"
              aria-label="Ir para listagem de candidatos." data-test="linkAdmissionDashboard">Admissão</a>
          </li>
          <li *ngIf="hasCollaborators">
            <details class="collapse">
              <summary class="option-menu ico-colaborators" data-test="infoTitleModalRulesDetails">
                <p>
                  Colaboradores
                </p>
              </summary>
              <ul>
                <li>
                  <a href="{{collaboratorUrl}}" (click)="toggleMenu('listing')" class="option-menu"
                    aria-label="Ir para a listagem de colaboradores." data-test="linkOngoingDashboard">Listagem</a>
                </li>
                <li>
                  <a href="{{collaboratorUrl + '/new'}}" (click)="toggleMenu('import')" class="option-menu"
                    aria-label="Ir para importar colaboradores."
                    data-test="linkOngoingDashboardImportEmployee">Importação</a>
                </li>
                <li>
                  <a href="{{collaboratorUrl + '/processing-status'}}" (click)="toggleMenu('history')"
                    class="option-menu" aria-label="Ir para histórico de importação."
                    data-test="linkOngoingDashboardProcessingEmployee">
                    Histórico de Importação
                  </a>
                </li>
              </ul>
            </details>
          </li>
          <li data-test="menu_item_signatures">
            <details class="collapse">
              <summary class="option-menu ico-signatures">
                <p>Assinaturas</p>
              </summary>
              <ul>
                <li>
                  <a href="{{baseUrl + '/signatures'}}" (click)="toggleMenu()"
                    aria-label="Ir para gestão de assinaturas" class="option-menu">
                    Gestão de assinaturas
                  </a>
                </li>
                <li>
                  <a *ngIf="!enableNewModelsList" href="{{baseUrl + '/company/models'}}" (click)="toggleMenu()"
                    aria-label="Ir para gestão de modelos" class="option-menu">
                    Gestão de modelos
                  </a>

                  <a *ngIf="enableNewModelsList" href="{{baseUrl + '/company/models-list'}}" (click)="toggleMenu()"
                    aria-label="Ir para gestão de modelos" class="option-menu">
                    Gestão de modelos
                  </a>
                </li>
              </ul>
            </details>
          </li>
          <li>
            <a href="{{baseUrl + '/company'}}" (click)="toggleMenu()" aria-label="Ir para as configurações da empresa."
              data-test="linkAdmissionSettings" class="option-menu ico-settings isActive">Configurações</a>
          </li>
          <li *ngIf="showBenefitsProductivity">
            <a routerLink="/productivity" (click)="toggleMenu()" aria-label="Ir para produtividade."
              class="option-menu ico-productivity">Produtividade</a>
          </li>
        </ul>
      </div>
      <div class="sidebar-menu" *ngIf="hasSignature">
        <h3 class="sidebar-account_subtitle">Grupo</h3>
        <ul>
          <li>
            <a *ngIf="hasSignature && !flagActiveModelsListModule" href="{{singUrl}}"
              aria-label="Ir para Assinatura Eletrônica" class="option-menu ico-sign">Assinatura Eletrônica</a>
            <a *ngIf="hasSignature && flagActiveModelsListModule" href="{{singUrl}}"
              aria-label="Ir para as configurações da empresa." class="option-menu ico-sign">Unico Sign</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="sidebar-company-submenu sidebar-submenu" [ngClass]="{'open' : company }" *ngIf="company">
      <up-ui-companies-sidebar [companies]="list" [acc]="acc?.uid"
        (change)="changeCompany($event)"></up-ui-companies-sidebar>
    </div>
  </aside>
</div>